// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── StackedBarChart — Premium Metric Visualization ─── */
.StackedBarChart_stacked-chart__D4AH\\+ {
  padding: 28px 28px 24px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}
.StackedBarChart_stacked-chart--embed__fDYZk {
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}
.StackedBarChart_stacked-chart__header__PrYKr {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.StackedBarChart_stacked-chart__title__KwKmt {
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
  line-height: 1.25;
}
.StackedBarChart_stacked-chart__description__n-2Z2 {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--grey-text, #888);
  margin-top: 4px;
}

/* ─── Inline Horizontal Legend ─── */
.StackedBarChart_legend__z5Enw {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 8px 0;
}

.StackedBarChart_legend-item__6tDdY {
  display: flex;
  align-items: center;
  gap: 6px;
}

.StackedBarChart_legend-swatch__fMeCi {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
}

.StackedBarChart_legend-name__wKOsI {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-1, #333);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

/* ─── Metric Grid ─── */
.StackedBarChart_charts-grid__I9U7b {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Individual Metric Row ─── */
.StackedBarChart_overlap-chart__uj2AU {
  position: relative;
  background: rgba(0, 0, 0, 0.015);
  border-radius: 10px;
  padding: 18px 20px;
}
.StackedBarChart_overlap-chart__head__pKS8I {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.StackedBarChart_overlap-chart__category__vQCDI {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--text-1, #1a1a1a);
  margin-bottom: 2px;
}
.StackedBarChart_overlap-chart__label__gQG6G {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
  line-height: 1.3;
}
.StackedBarChart_overlap-chart__annotation__vGY-2 {
  font-size: 12px;
  font-weight: 500;
  font-style: italic;
  color: var(--grey-text, #999);
  white-space: nowrap;
}
.StackedBarChart_overlap-chart__bars__J2rKq {
  min-height: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(15, 52, 96, 0.08);
}

/* ─── Bar Layers ─── */
.StackedBarChart_bar-layer__guXi5 {
  display: flex;
  min-width: 0;
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.45);
}
.StackedBarChart_bar-layer__guXi5:last-child {
  border-right: none;
}

.StackedBarChart_bar__KRDEB {
  height: 100%;
  width: 100%;
  border-radius: 0;
  cursor: default;
  pointer-events: auto;
  opacity: 0.95;
}
.StackedBarChart_bar__KRDEB:hover {
  filter: brightness(1.08);
}

/* ─── Tooltip ─── */
.StackedBarChart_bar-tooltip__uOLRL {
  position: absolute;
  z-index: 20;
  pointer-events: none;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 12px 16px;
  min-width: 190px;
  white-space: nowrap;
}
.StackedBarChart_bar-tooltip__header__rjuMf {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.StackedBarChart_bar-tooltip__name__IRKAx {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-1, #1a1a1a);
  line-height: 1.3;
  white-space: normal;
  max-width: 200px;
}
.StackedBarChart_bar-tooltip__stat__wV3MX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.StackedBarChart_bar-tooltip__stat-label__Pxoxe {
  font-size: 12px;
  color: var(--grey-text, #666);
}
.StackedBarChart_bar-tooltip__stat-value__SjVZq {
  font-size: 15px;
  font-weight: 700;
  color: var(--accent-color, #0f3460);
  font-variant-numeric: tabular-nums;
}

.StackedBarChart_tooltip-logo__kb15s {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: contain;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.StackedBarChart_tooltip-logo-fallback__JpvHW {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: var(--accent-color-light, #e8eef5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: var(--accent-color, #0f3460);
  flex-shrink: 0;
}

/* ─── Responsive ─── */
@media only screen and (max-width: 768px) {
  .StackedBarChart_stacked-chart__D4AH\\+ {
    padding: 20px 16px;
    border-left-width: 2px;
  }
  .StackedBarChart_stacked-chart__header__PrYKr {
    flex-direction: column;
    gap: 12px;
  }
  .StackedBarChart_stacked-chart__title__KwKmt {
    font-size: 18px;
  }
  .StackedBarChart_legend__z5Enw {
    gap: 12px;
  }
  .StackedBarChart_overlap-chart__uj2AU {
    padding: 14px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/StackedBarChart/StackedBarChart.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,2DAAA;AAEA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;AACE;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,eAAA;AAFJ;;AAMA,qCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,yBAAA;AAHF;;AAMA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA,kCAAA;AACA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAKE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAHJ;AAME;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AANJ;AASE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;AAPJ;;AAWA,uBAAA;AACA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,iDAAA;AARF;AAUE;EACE,kBAAA;AARJ;;AAYA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;AATF;AAWE;EACE,wBAAA;AATJ;;AAaA,oBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAZJ;AAeE;EACE,eAAA;EACA,6BAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AAdJ;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;AAfF;;AAkBA,uBAAA;AACA;EACE;IACE,kBAAA;IACA,sBAAA;EAfF;EAiBE;IACE,sBAAA;IACA,SAAA;EAfJ;EAkBE;IACE,eAAA;EAhBJ;EAoBA;IACE,SAAA;EAlBF;EAqBA;IACE,kBAAA;EAnBF;AACF","sourcesContent":["/* ─── StackedBarChart — Premium Metric Visualization ─── */\n\n.stacked-chart {\n  padding: 28px 28px 24px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n\n  &--embed {\n    padding: 0;\n    background: transparent;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 28px;\n    flex-wrap: wrap;\n  }\n\n  &__title {\n    font-family: \"Lora\", \"Georgia\", serif;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a1a);\n    line-height: 1.25;\n  }\n\n  &__description {\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    color: var(--grey-text, #888);\n    margin-top: 4px;\n  }\n}\n\n/* ─── Inline Horizontal Legend ─── */\n.legend {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 8px 0;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.legend-swatch {\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.legend-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-1, #333);\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n/* ─── Metric Grid ─── */\n.charts-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ─── Individual Metric Row ─── */\n.overlap-chart {\n  position: relative;\n  background: rgba(0, 0, 0, 0.015);\n  border-radius: 10px;\n  padding: 18px 20px;\n\n  &__head {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  &__category {\n    display: block;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.2px;\n    color: var(--text-1, #1a1a1a);\n    margin-bottom: 2px;\n  }\n\n  &__label {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a1a);\n    line-height: 1.3;\n  }\n\n  &__annotation {\n    font-size: 12px;\n    font-weight: 500;\n    font-style: italic;\n    color: var(--grey-text, #999);\n    white-space: nowrap;\n  }\n\n  &__bars {\n    min-height: 20px;\n    height: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    border-radius: 4px;\n    overflow: hidden;\n    background: rgba(15, 52, 96, 0.08);\n  }\n}\n\n/* ─── Bar Layers ─── */\n.bar-layer {\n  display: flex;\n  min-width: 0;\n  height: 100%;\n  border-right: 1px solid rgba(255, 255, 255, 0.45);\n\n  &:last-child {\n    border-right: none;\n  }\n}\n\n.bar {\n  height: 100%;\n  width: 100%;\n  border-radius: 0;\n  cursor: default;\n  pointer-events: auto;\n  opacity: 0.95;\n\n  &:hover {\n    filter: brightness(1.08);\n  }\n}\n\n/* ─── Tooltip ─── */\n.bar-tooltip {\n  position: absolute;\n  z-index: 20;\n  pointer-events: none;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  padding: 12px 16px;\n  min-width: 190px;\n  white-space: nowrap;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  &__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-1, #1a1a1a);\n    line-height: 1.3;\n    white-space: normal;\n    max-width: 200px;\n  }\n\n  &__stat {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__stat-label {\n    font-size: 12px;\n    color: var(--grey-text, #666);\n  }\n\n  &__stat-value {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--accent-color, #0f3460);\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.tooltip-logo {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  object-fit: contain;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.tooltip-logo-fallback {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  background: var(--accent-color-light, #e8eef5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--accent-color, #0f3460);\n  flex-shrink: 0;\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 768px) {\n  .stacked-chart {\n    padding: 20px 16px;\n    border-left-width: 2px;\n\n    &__header {\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    &__title {\n      font-size: 18px;\n    }\n  }\n\n  .legend {\n    gap: 12px;\n  }\n\n  .overlap-chart {\n    padding: 14px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stacked-chart": `StackedBarChart_stacked-chart__D4AH+`,
	"stacked-chart--embed": `StackedBarChart_stacked-chart--embed__fDYZk`,
	"stacked-chart__header": `StackedBarChart_stacked-chart__header__PrYKr`,
	"stacked-chart__title": `StackedBarChart_stacked-chart__title__KwKmt`,
	"stacked-chart__description": `StackedBarChart_stacked-chart__description__n-2Z2`,
	"legend": `StackedBarChart_legend__z5Enw`,
	"legend-item": `StackedBarChart_legend-item__6tDdY`,
	"legend-swatch": `StackedBarChart_legend-swatch__fMeCi`,
	"legend-name": `StackedBarChart_legend-name__wKOsI`,
	"charts-grid": `StackedBarChart_charts-grid__I9U7b`,
	"overlap-chart": `StackedBarChart_overlap-chart__uj2AU`,
	"overlap-chart__head": `StackedBarChart_overlap-chart__head__pKS8I`,
	"overlap-chart__category": `StackedBarChart_overlap-chart__category__vQCDI`,
	"overlap-chart__label": `StackedBarChart_overlap-chart__label__gQG6G`,
	"overlap-chart__annotation": `StackedBarChart_overlap-chart__annotation__vGY-2`,
	"overlap-chart__bars": `StackedBarChart_overlap-chart__bars__J2rKq`,
	"bar-layer": `StackedBarChart_bar-layer__guXi5`,
	"bar": `StackedBarChart_bar__KRDEB`,
	"bar-tooltip": `StackedBarChart_bar-tooltip__uOLRL`,
	"bar-tooltip__header": `StackedBarChart_bar-tooltip__header__rjuMf`,
	"bar-tooltip__name": `StackedBarChart_bar-tooltip__name__IRKAx`,
	"bar-tooltip__stat": `StackedBarChart_bar-tooltip__stat__wV3MX`,
	"bar-tooltip__stat-label": `StackedBarChart_bar-tooltip__stat-label__Pxoxe`,
	"bar-tooltip__stat-value": `StackedBarChart_bar-tooltip__stat-value__SjVZq`,
	"tooltip-logo": `StackedBarChart_tooltip-logo__kb15s`,
	"tooltip-logo-fallback": `StackedBarChart_tooltip-logo-fallback__JpvHW`
};
export default ___CSS_LOADER_EXPORT___;
